import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

import RichText from '@/app/components/RichText';

import type { PopAccuracyComfortSectionHighlightData } from '../types';

export interface MobileHighlightsProps {
  readonly highlights: PopAccuracyComfortSectionHighlightData[];
}

const MobileHighlights = ({ highlights }: MobileHighlightsProps) => {
  const t = useTranslations();

  return (
    <div
      className="mt-11 flex flex-col gap-y-10 md:js:hidden"
      data-cy="pop-accuracy-comfort-section-highlights-mobile"
    >
      {highlights.map((highlight) => (
        <div key={highlight.title}>
          <Typography
            className="mb-1 text-heading-base leading-tighter tracking-tighter text-current lg:mb-2 lg:text-2xl"
            Element="h3"
          >
            {t(highlight.title)}
          </Typography>
          <Typography className="max-w-72 text-current lg:text-sm">
            <RichText messageKey={highlight.copy} />
          </Typography>
        </div>
      ))}
    </div>
  );
};

export default MobileHighlights;
